import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../api/auth';
import BrandLogo from '../components/BrandLogo';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const inputClass =
  'flex h-11 w-full rounded-lg border border-input bg-card px-4 py-2 text-sm transition-colors placeholder:text-muted-foreground focus-visible:border-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await forgotPassword(email);
      if (result.error) setError(result.error);
      else setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-muted/50 p-6 pt-safe pb-safe">
      <Card className="w-full max-w-sm shadow-sm">
        <CardContent className="p-6 sm:p-8">
          <BrandLogo className="mb-6" width={160} />

          {sent ? (
            <div className="space-y-4 text-center">
              <p className="text-sm text-foreground">
                If that email address is registered, you'll receive a password reset link shortly.
              </p>
              <p className="text-xs text-muted-foreground">Check your spam folder if it doesn't arrive within a few minutes.</p>
              <Link to="/login" className="block text-sm font-medium text-primary hover:underline">
                Back to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <h1 className="text-base font-semibold text-foreground">Reset your password</h1>
                <p className="mt-1 text-sm text-muted-foreground">Enter your email and we'll send a reset link.</p>
              </div>

              {error && (
                <div className="rounded-lg border border-destructive/20 bg-destructive/10 px-3 py-2 text-sm text-destructive">
                  {error}
                </div>
              )}

              <div>
                <label htmlFor="email" className="mb-1 block text-sm font-medium text-foreground">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={inputClass}
                  required
                />
              </div>

              <Button type="submit" disabled={loading} className="w-full" size="lg">
                {loading ? 'Sending…' : 'Send reset link'}
              </Button>

              <p className="text-center text-sm text-muted-foreground">
                <Link to="/login" className="font-medium text-primary hover:underline">
                  Back to sign in
                </Link>
              </p>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
